import { useTranslation } from "react-i18next"
import { ReactNode } from "react"
import { Alert, Box } from "@mui/material"
import { Folder, PdfFile } from "../../../shared/src/types/Content"

import Link from "../../Elements/Link"
import Thumbnail from "../../Elements/Thumbnail"
import UxIcon from "../../Elements/UxIcon"
import { observer } from "mobx-react-lite"


export const VisibilityWarning = ({folderIsHidden, hidden}: {folderIsHidden?: boolean, hidden: boolean|undefined}) => {
  const { t } = useTranslation()
  if(hidden) return (
    <Alert sx={{padding: "4px 15px"}} severity="warning">
      {folderIsHidden ? t('Folder not visible to other pod users')  : t('Not visible to other pod users')}
    </Alert>
  )
  return null
}

export const MaterialItem = observer(({children, expanded, item, itemType, materialView, podId}: {children: ReactNode, expanded?: boolean, item: PdfFile|Folder, itemType: 'file'|'folder', materialView?: string, podId?: string}) => {
  // wrap with link container if item is a file
  const Wrapper = ({children, sx}: {children: ReactNode, sx: object}) => {
    const fileItem = item as unknown as PdfFile
    if(itemType === "file" && podId && item && (fileItem.status === 'complete')) {
      const file = item as PdfFile
      return (
        <Link noDecoration={true} sx={sx} to={`/pod/${podId}/pdf/${file.nodeId}/`}>
          {children}
        </Link>
      )
    }
    else return (
      <Box sx={sx}>
        {children}
      </Box>
    )
  }

  return (
    <Box sx={{
      alignItems: "center",
      display: "flex",
      flexWrap: "wrap",
      gap: "15px",
      justifyContent: "end",
      padding: "10px 15px"
    }}>
      <Wrapper sx={{
        alignContent: "center",
        alignItems: "center",
        display: "grid",
        flexGrow: 1,
        gap: "10px",
        gridTemplateColumns: "max-content auto",
        opacity: item.hidden ? 0.5 : 1,
        wordWrap: "break-word"
      }}>
        {(itemType === "file" && materialView === "tiles") ?
          <FilePreview file={item as PdfFile} padding={"15px 25px"} /> :
          <UxIcon id={itemType === 'file' ? "podFile" : (expanded ? "podFolderOpen" : "podFolder")} />
        }
        <Box sx={{color: itemType === "folder" ? "textcolor.light" : "", display: "grid", fontSize: "16px", fontWeight: itemType === "folder" ? 550 : "", padding: "5px", wordBreak: "break-word"}}>
          {item.name}
          <Box sx={{fontWeight: 300, padding: (itemType === "folder" && item.description) ? "5px 30px 0 0" : "", maxWidth: "600px"}}>
            {item.description}
          </Box>
        </Box>
      </Wrapper>
      {children}
    </Box>
  )
})

export const FilePreview = ({file, padding, width}: {file: PdfFile, padding: string, width?: number}) => {
  const thumbnailbHeight = 300
  return (
    <Box sx={{
      backgroundColor: "back.main",
      borderRadius: "10px",
      height: "90px",
      justifyItems: "center",
      overflow: "hidden",
      padding: padding
    }}>
      <Thumbnail key={file.nodeId} height={thumbnailbHeight} width={width ? width : 250} nodeId={file.nodeId} pageNumber={1} />
    </Box>
  )
}
